import { Link } from "react-router-dom";

export default function Qualitaet() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Page Header */}
      <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-4 md:mb-6">
              <Link to="/" className="hover:text-primary-600 transition-colors">Startseite</Link>
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
              <span className="text-foreground-700">Qualität & Umwelt</span>
            </nav>
            <h1 className="font-heading font-bold text-foreground-900 text-3xl md:text-4xl lg:text-5xl mb-3 md:mb-4">
              Qualität & Umwelt
            </h1>
            <p className="text-foreground-600 max-w-2xl text-sm md:text-base">
              Nachhaltige Galvanik und höchste Qualitätsansprüche sind die Grundlage unseres unternehmerischen Handelns.
            </p>
          </div>
        </div>
      </section>

      {/* Quality Standards */}
      <section className="py-10 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-8 md:mb-12 text-center">
              Unsere Qualitätsstandards
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {[
                {
                  icon: "ri-file-list-3-line",
                  title: "DIN-Normen",
                  desc: "Alle Beschichtungsprozesse entsprechen den aktuellen DIN-Normen und branchenspezifischen Spezifikationen der Automobilzulieferindustrie.",
                },
                {
                  icon: "ri-microscope-line",
                  title: "Laborprüfung",
                  desc: "Umfangreiche Laboranalysen gewährleisten die Einhaltung von Schichtdicken, Haftfestigkeit und Korrosionsschutzeigenschaften.",
                },
                {
                  icon: "ri-shield-check-line",
                  title: "Prozesskontrolle",
                  desc: "Kontinuierliche Überwachung aller Galvanikbäder und Prozessparameter für gleichbleibende Produktqualität.",
                },
              ].map((item) => (
                <div key={item.title} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-50 rounded-md mb-3 md:mb-4">
                    <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-primary-500 text-lg md:text-xl">
                      <i className={item.icon} />
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Environment */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 uppercase tracking-wide">
                Umweltschutz
              </span>
              <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-4 md:mb-6">
                Nachhaltigkeit als Unternehmensziel
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4 text-sm md:text-base">
                Unsere Firmenmitarbeiter mit den Aufgabenschwerpunkten Verzinken, Phosphatieren und Brünieren von Trommel- und Gestellware haben sich zum Ziel gesetzt, den heutigen und zukünftigen Forderungen eines nachhaltigen Umweltschutzes zum Wohle aller voll zu entsprechen.
              </p>
              <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
                Wir setzen auf umweltfreundliche Beschichtungsprozesse, den Einsatz moderner Abwasseraufbereitungsanlagen und die Reduktion des Energieverbrauchs durch effiziente Anlagentechnik.
              </p>
              <ul className="space-y-2 md:space-y-3">
                {[
                  "Moderne Abwasseraufbereitung und Kreislaufsysteme",
                  "Energieeffiziente Anlagentechnik und Wärmerückgewinnung",
                  "Reduzierung von Chemikalieneinsatz durch Prozessoptimierung",
                  "Kontinuierliche Mitarbeiterschulung zu Umweltthemen",
                  "Einhaltung aller gesetzlichen Umweltauflagen",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-foreground-700">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5 text-accent-500">
                      <i className="ri-checkbox-circle-line" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/a9beae72ce070f8c28f07fa94c7d3e14/06d98fdda496bcac36561a30561a2776.png"
                alt="DIN EN ISO 9001:2015 Zertifikat &ndash; Draude &amp; Wagner Galvanik GmbH &amp; Co. KG"
                className="w-full h-auto rounded-lg object-contain bg-white shadow-sm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-10 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-8 md:mb-12 text-center">
              Zertifizierungen & Normen
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {[
                { name: "DIN EN ISO 9001", desc: "Qualitätsmanagement-System" },
                { name: "DIN EN ISO 14001", desc: "Umweltmanagement-System" },
                { name: "IATF 16949", desc: "Automotive Qualitätsstandard" },
                { name: "REACH / RoHS", desc: "Chemikalien- und Stoffverordnung" },
              ].map((cert) => (
                <div key={cert.name} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-accent-50 rounded-full mx-auto mb-3 md:mb-4">
                    <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-accent-500 text-lg md:text-xl">
                      <i className="ri-award-line" />
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                    {cert.name}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm">
                    {cert.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testing */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <img
                src="https://readdy.ai/api/search-image?query=Industrial%20quality%20testing%20equipment%20with%20digital%20displays%20measuring%20metal%20coating%20thickness%2C%20clean%20modern%20laboratory%20setting%2C%20warm%20lighting%2C%20professional%20photography%2C%20high%20detail%20precision%20instruments&width=800&height=600&seq=testing-dw&orientation=landscape"
                alt="Qualitätsprüfung im Labor"
                className="w-full h-auto rounded-lg object-cover aspect-[4/3]"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-4 md:mb-6">
                Unsere Prüfverfahren
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
                Jeder Produktionscharge unterziehen wir umfassenden Prüfungen, um die Einhaltung aller Qualitätsvorgaben zu gewährleisten.
              </p>
              <div className="space-y-3 md:space-y-4">
                {[
                  { title: "Schichtdickenmessung", desc: "Präzise Messung nach magnetischem/elektromagnetischem Verfahren nach DIN EN ISO 2178." },
                  { title: "Haftprüfung", desc: "Kreuzschnitt- und Klebebandtest nach DIN EN ISO 2409 zur Haftfestigkeitsprüfung." },
                  { title: "Korrosionsprüfung", desc: "Salzsprühnebeltest nach DIN EN ISO 9227 zur Bestimmung der Korrosionsbeständigkeit." },
                  { title: "Härteprüfung", desc: "Bestimmung der Oberflächenhärte nach Vickers nach DIN EN ISO 6507." },
                ].map((test) => (
                  <div key={test.title} className="bg-background-100 rounded-lg p-3 md:p-4 border border-background-200/70">
                    <h4 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                      {test.title}
                    </h4>
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                      {test.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}